import { Id, retrieveTaskError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (taskId: Id) =>
    present(
      repository.getTask(taskId).catch((e) =>
        Promise.reject({
          error: { ...retrieveTaskError, ...e },
          taskId,
        }),
      ),
    );
}

export type { Interactor };

export { createInteractor };
